import React from "react";
import "./ContactSection.css";
import { FiPhone, FiMail } from "react-icons/fi";

const ContactSection = () => {
  return (
    <section className="contact-section">
      {/* Map */}
      <div className="map-container">
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.0306916793763!2d77.53763077590682!3d12.903201017194024!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3dfce013fb6f%3A0x4b089a7b4d9f3d71!2sVijayanagar%2C%20Bengaluru%2C%20Karnataka%20560040!5e0!3m2!1sen!2sin!4v1699876543210!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>

      {/* Contact Strip */}
      <div className="container contact-strip row d-flex justify-content-center align-items-center">
          <div className="col-md-4 contact-item address">
            <h4>Registered Office</h4>
            <p>No.121, 1st Floor, Eshwar Plaza, 4th Main Road,  
            1st Phase, 1st Stage, Manjunatha Nagar,
            West of Cord Road, Bangalore-560010.</p>
          </div>
         <div className="col-md-4 contact-item phone">
        <div className="icon red-bg">
          <FiPhone size={20} />
        </div>
        <div>
  <small>COMPANY PHONES</small>
  <p>
    <a href="tel:+919902043004">+91 99020 43004</a>
  </p>
  <p>
    <a href="tel:+919902043004">+91 99020 43004</a>
  </p>
</div>
      </div>

      <div className="col-md-4 contact-item email">
        <div className="icon blue-bg">
          <FiMail size={20} />
        </div>
        <div>
  <small>EMAILS</small>
  <p>
    <a href="mailto:vmanik@novaedubridge.com">vmnaik@novaedubridge.com</a>
  </p>
  <p>
    <a href="mailto:info@novaedubridge.com">info@novaedubridge.com</a>
  </p>
</div>
      </div>
        </div>
    </section>
  );
};

export default ContactSection;
